import { render, staticRenderFns } from "./courseManage.vue?vue&type=template&id=fb3b087a&"
import script from "./courseManage.vue?vue&type=script&lang=js&"
export * from "./courseManage.vue?vue&type=script&lang=js&"
import style0 from "./courseManage.vue?vue&type=style&index=0&id=fb3b087a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports